"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardBodyMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class PropertyCardBodyMixin */
/** @method */
var PropertyCardBodyMixin = function PropertyCardBodyMixin() {
  return (0, _styledToken.default)({
    // Same as Card
    borderRadius: 'PropertyCard.cardBody.borderRadius'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius;
    return (0, _styledComponents.css)(["border-radius:", "px;"], borderRadius);
  });
};
exports.PropertyCardBodyMixin = PropertyCardBodyMixin;